import React, { useState } from "react";

const faqData = [
  {
    question: "What makes Spruha-Day'S pads different?",
    answer:
      "Spruha-Days pads are infused with graphene and herbs that help prevent rashes, reduce cramps, and provide a refreshing experience. They're safe, eco-friendly, and free from harmful chemicals.",
  },
  {
    question: "Are Spruha-Day'S sanitary pads safe for sensitive skin?",
    answer:
      "Yes! Our pads are made with soft cotton and herbal layers, making them suitable for even the most sensitive skin types.",
  },
  {
    question: "How are Graphene pads beneficial?",
    answer:
      "Graphene emits far-infrared energy that helps improve blood circulation and relieve menstrual pain naturally.",
  },
  {
    question: "How do I choose the right pad size?",
    answer:
      "You can choose from Small (Panty Liner), Medium (Regular flow), and Large (Heavy flow) based on your needs. We also offer combo packs.",
  },
  {
    question: "Do you offer COD or free delivery?",
    answer:
      "Yes, we offer Cash on Delivery (COD) and free delivery on all orders above ₹399 across India.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section style={styles.container}>
      <h1 style={styles.heading}>
        Frequently Asked Questions
        <span style={styles.headingUnderline}></span>
      </h1>
      <div style={styles.faqList}>
        {faqData.map((item, index) => (
          <div
            key={index}
            style={{
              ...styles.faqItem,
              boxShadow:
                openIndex === index
                  ? "0 4px 20px rgba(233,30,99,0.4)"
                  : "0 2px 5px rgba(0,0,0,0.1)",
              border:
                openIndex === index
                  ? "2px solid #E91E63"
                  : "2px solid transparent",
            }}
          >
            <div style={styles.question} onClick={() => toggleFAQ(index)}>
              <span>{item.question}</span>
              <span
                style={{
                  ...styles.icon,
                  transform:
                    openIndex === index ? "rotate(45deg)" : "rotate(0deg)",
                }}
              >
                +
              </span>
            </div>
            <div
              style={{
                ...styles.answerWrapper,
                maxHeight: openIndex === index ? "500px" : "0px",
                padding: openIndex === index ? "10px 0" : "0",
              }}
            >
              <p style={styles.answer}>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const styles = {
  container: {
    maxWidth: "800px",
    margin: "0 auto 40px auto",
    padding: "20px",
    fontFamily: '"Playfair Display", serif',
  },
  heading: {
    fontSize: "32px",
    textAlign: "center",
    marginTop: "30px",
    marginBottom: "50px",
    fontWeight: "700",
    background: "linear-gradient(rgb(6, 6, 6),rgb(10, 10, 10))",
    WebkitBackgroundClip: "text",
    color: "transparent",
    fontFamily: '"Playfair Display", serif',
    position: "relative",
  },
  headingUnderline: {
    content: '""',
    display: "block",
    width: "60px",
    height: "4px",
    background: "#e91e63",
    margin: "10px auto 0",
    borderRadius: "2px",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    bottom: "-15px",
  },
  faqList: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  faqItem: {
    background: "linear-gradient(145deg, #fff, #f9f9f9)",
    borderRadius: "10px",
    padding: "15px 20px",
    transition: "all 0.4s ease",
    overflow: "hidden",
    fontFamily: '"Playfair Display", serif',
  },
  question: {
    fontWeight: "600",
    fontSize: "1.1rem",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#333",
    fontFamily: '"Playfair Display", serif',
  },
  icon: {
    fontSize: "1.5rem",
    color: "#E91E63",
    transition: "transform 0.3s ease",
  },
  answerWrapper: {
    overflow: "hidden",
    transition: "all 0.4s ease",
  },
  answer: {
    color: "#555",
    lineHeight: "1.6",
    fontSize: "1rem",
    margin: 0,
    fontFamily: '"Playfair Display", serif',
  },
};

export default FAQ;